import * as React from 'react';
import { observer } from 'mobx-react';
import LearningCollectionStore from '../../../Store';
import { ProductLicenseResource } from '../../../../Types';
import { emptyFragment } from '../../../../../../EmptyFragment';
import { checkedStatus } from './ActiveProductLicense/Selection';
import { AlreadyTranslated, T } from '../../../../../../Translations';

interface Props {
  store: LearningCollectionStore;
  inactiveProductLicenses: ProductLicenseResource;
  dataIntercomTarget?: string;
}

const InActiveProductLicense: React.FC<Props> = ({
  store,
  inactiveProductLicenses,
  dataIntercomTarget,
}) => {
  return (
    <div
      className="opacity-50 drop-shadow"
      key={inactiveProductLicenses.payload.id}
      data-intercom-target={dataIntercomTarget}
    >
      <label className="mb-6 flex cursor-not-allowed items-start rounded-md bg-white p-6">
        <input
          type="radio"
          name="selectedLearningDesign"
          value={inactiveProductLicenses.payload.id}
          className="mt-1 inline-block h-5 w-5 text-teal-600"
          checked={checkedStatus(store.selectedProductLicense, inactiveProductLicenses)}
          readOnly
          disabled
        />
        <div className="ml-4 flex w-full justify-between">
          <div>
            <h3 className="text-base font-medium">
              {inactiveProductLicenses.payload.licenseTypePublicName
                .map((licenseTypePublicName) => (
                  <AlreadyTranslated content={licenseTypePublicName} />
                ))
                .getOrElse(emptyFragment)}
            </h3>
            <div className="flex">
              <p className="-ml-9 pt-2.5 text-sm">
                <T
                  kind="{{count}} License Available"
                  count={inactiveProductLicenses.payload.licenseQuantity}
                />
              </p>
              <p className="ml-8 pt-2.5 text-sm">
                <T kind="Contact your ExecOnline representative to add licenses." />
              </p>
            </div>
            <p className="-ml-9 pt-2.5 text-sm">
              {inactiveProductLicenses.payload.licenseTypePublicDescription
                .map((licenseTypePublicDescription) => (
                  <AlreadyTranslated content={licenseTypePublicDescription} />
                ))
                .getOrElse(emptyFragment)}
            </p>
          </div>
        </div>
      </label>
    </div>
  );
};

export default observer(InActiveProductLicense);
